// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__bPERm","additionalInfo":"AgreementModal_additionalInfo__1nuzI"};